import kitchenInstance from '../instance'

const updateKitchenOrderProductStatus = (orderId, itemPositionId, data) => {
  return kitchenInstance.put('/orders/' + orderId + '/items/' + itemPositionId + '/status', data)
}

export default updateKitchenOrderProductStatus
